const KEY = 'cbs_utm';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

interface StoredUtm {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  saved_at: number;
}

function readStored(): StoredUtm | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredUtm;
    if (!parsed || typeof parsed.saved_at !== 'number' || Date.now() - parsed.saved_at > TTL_MS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function captureUtm(): void {
  try {
    if (readStored()) return;
    const params = new URLSearchParams(window.location.search);
    const utm_source = params.get('utm_source')?.trim().slice(0, 60);
    const utm_medium = params.get('utm_medium')?.trim().slice(0, 60);
    const utm_campaign = params.get('utm_campaign')?.trim().slice(0, 80);
    if (!utm_source && !utm_medium && !utm_campaign) return;
    const value: StoredUtm = { utm_source, utm_medium, utm_campaign, saved_at: Date.now() };
    window.localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // storage unavailable: ignore
  }
}

export function withUtmSource(existing: string): string {
  try {
    const stored = readStored();
    if (!stored || (!stored.utm_source && !stored.utm_campaign)) return existing;
    return `${stored.utm_source || ''}|${stored.utm_campaign || ''}|${existing}`;
  } catch {
    return existing;
  }
}
